export default __webpack_public_path__ + "d8c148221d141051be9f00abca53de7d.png";